import React, { createContext, useState, useEffect, useContext } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [userId, setUserId] = useState(null); // Agrega el estado para el Id de usuario
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    const savedUserId = localStorage.getItem('userId'); // Obtén el Id de usuario del almacenamiento local
    if (savedToken) {
      setToken(savedToken);
      setUserId(savedUserId); // Establece el Id de usuario almacenado
    }
    setLoading(false);
  }, []);

  const login = (newToken, newUserId) => {
    setToken(newToken);
    setUserId(newUserId); // Establece el Id de usuario al iniciar sesión
    localStorage.setItem('token', newToken);
    localStorage.setItem('userId', newUserId); // Almacena el id de usuario en el almacenamiento local
  };

  const logout = () => {
    setToken(null);
    setUserId(null); // Borra el Id de usuario al cerrar sesión
    localStorage.removeItem('token');
    localStorage.removeItem('userId'); // Borra el Id de usuario del almacenamiento local
  };

  return (
    <AuthContext.Provider value={{ token, userId, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
